import PropTypes from 'prop-types';
import { FiGithub, FiLinkedin } from 'react-icons/fi';
import { AiOutlineMail } from 'react-icons/ai';
import { BiHomeAlt } from 'react-icons/bi';
import { siteConfig } from '../config/siteConfig';

const SideBar = () => (
    <div className='fixed bottom-0 left-0 right-0 h-16 md:top-0 md:bottom-auto md:right-auto md:h-screen md:w-16 lg:w-20 m-0 flex justify-center z-50'>
        <div className='absolute inset-0 bg-slate-900/80 backdrop-blur-md border-t border-slate-800/50 md:border-t-0 md:border-r md:border-slate-800/50'></div>

        <div className='relative flex flex-row md:flex-col h-full w-full px-4 md:px-0 py-0 md:py-6 items-center justify-center md:justify-start'>
            {/* Logo/Home */}
            <a href={siteConfig.routes.home} className='md:mb-8'>
                <div className='flex items-center justify-center h-10 w-10 lg:h-12 lg:w-12 bg-emerald-600 rounded-xl shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300'>
                    <BiHomeAlt size="24" className='text-white' />
                </div>
            </a>

            {/* Divider */}
            <div className='w-px h-8 md:w-auto md:h-px bg-slate-800/50 mx-3 md:mx-auto md:my-0 md:mb-4'></div>

            {/* Social Icons */}
            <div className='flex-1 flex flex-row md:flex-col justify-center items-center gap-2 md:w-full'>
                <a href={siteConfig.social.github} target="_blank" rel="noopener noreferrer">
                    <SideBarIcon tooltip='GitHub' icon={<FiGithub size="20" />} />
                </a>
                <a href={siteConfig.social.linkedin} target="_blank" rel="noopener noreferrer">
                    <SideBarIcon tooltip='LinkedIn' icon={<FiLinkedin size="20" />} />
                </a>
                <a href={`mailto:${siteConfig.social.email}`}>
                    <SideBarIcon tooltip='Contact' icon={<AiOutlineMail size="20" />} />
                </a>
            </div>

            {/* Bottom Indicator */}
            <div className='hidden md:block md:mt-auto'>
                <div className='w-1 h-12 bg-slate-700/50 rounded-full mx-auto'></div>
            </div>
        </div>
    </div>
);

const SideBarIcon = ({ icon, tooltip = "tooltip" }) => (
    <div className='sidebar-icon group'>
        {icon}
        <span className='sidebar-tooltip group-hover:scale-100'>
            {tooltip}
        </span>
    </div>
);

SideBarIcon.propTypes = {
    icon: PropTypes.element.isRequired,
    tooltip: PropTypes.string
};

export default SideBar;